




















import { Component, Prop, Vue } from 'vue-property-decorator'
import QuestionReview from './QuestionReview.vue'

@Component({
  components: {
    QuestionReview
  }
})
export default class ReviewSurvey extends Vue {
  @Prop() basicSurveyDetails!: object;
  @Prop() surveyQuestionAnswers!: object;
}
